Ext.define('SA.BusinessTableController', {
    extend: 'SA.ViewController2',

    constructor(model) {
        this.callParent([model]);

        this.modeStates.onModeFirstActive('view', activeState => new SA.BusinessTableViewController({model, activeState}));
        this.modeStates.onModeFirstActive('edit', activeState => new SA.BusinessesEditController({model, activeState}));
    },

    activate(mode) {
        SA.HistoricalModeIndicator.maybeShow(this.model);
        SA.PageHeader.setView(this.model);
        SA.ViewChooser.setView(this.model);

        SA.SidebarState.create()
            .enableTabs(['locations', 'businesses'])
            .selectTab(SA.Sidebar.lastClickedLocationsTab() ? 'locations' : 'businesses')
            .setModel(this.model)
            .apply();

        this.modeStates.activate(mode);
    }
});